<ng-container *ngIf="editmode">
  <form #VCformfolderEdit="ngForm" class="list-two-line">
    <div class="layout-list-quickfilter">
      <div>
        <exg-input [(ngModel)]="headline" #VCheadline="ngModel"
                   [caption]="enumSvc.getFieldCaption('ReferenceGroup','refGroupHeadline')"
                   name="headline" type="text">
        </exg-input>
        <exg-textarea [(ngModel)]="description" #VCdesc="ngModel" class="app-background-neutral"
                      [caption]="enumSvc.getFieldCaption('ReferenceGroup','refGroupDesc')"
                      name="description" type="text">
        </exg-textarea>
      </div>
      <div class="app-drawer app-background-trans">
        <i class="search-filter-action far fa-times" (click)="resetForm(true)">
        </i>
        <i class="search-filter-action far fa-save"
           (click)="viewerActions.Update(dataClone.groupID, dataClone.groupUPT, {refGroupHeadline: dataClone.headline, refGroupDesc: dataClone.description})"
           [class.disabled]="!appSvc.helperObj.changed(this.inputData, this.dataClone)">
        </i>
      </div>
    </div>
  </form>
</ng-container>
